import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reactiveCurrencyFormat'
})
export class ReactiveCurrencyFormatPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
